<template>
  <div class="check-work-body">

    <!-- 搜索 -->
    <div class="search-wrap">
      <el-button size="mini" type="primary" @click="showAddDialog()" style="margin-right: 5px;" icon="el-icon-plus">添加管理员</el-button>
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="getList()" :loading="searchLoading">搜索</el-button>
    </div>

    <!-- 管理员列表 -->
    <div class="table-wrap">
      <el-table v-loading="searchLoading" :data="tableData">
        <el-table-column prop="user_name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="phone_number" label="手机号" align="center"></el-table-column>
        <el-table-column prop="department_name" label="部门" align="center"></el-table-column>
        <el-table-column prop="area_name" label="考勤点" align="center">
          <template slot-scope="scope">
            <router-link :to="{path: '/Oa/CheckWorkUser', query: {area_id: scope.row.area_id}}">{{scope.row.area_name}}({{scope.row.area_user_count}})</router-link>
          </template>
        </el-table-column>
        <el-table-column prop="workday_work_class" label="出勤设置" align="center">
          <template slot-scope="scope">
            {{scope.row.workday_class_name}}({{scope.row.workday_class_short_name}})
          </template>
        </el-table-column>
        <el-table-column prop="holiday_work_class" label="公休设置" align="center">
          <template slot-scope="scope">
            {{scope.row.holiday_class_name}}({{scope.row.holiday_class_short_name}})
          </template>
        </el-table-column>
        <el-table-column prop="status" label="权限" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" active-text="打开" inactive-text="关闭" @change="(val) => updateStatus(scope.row.id, val)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="showAddDialog(scope.row)">修改</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteAdmin(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
    </div>

    <!-- 添加窗口 -->
    <el-dialog title="添加管理员" :visible.sync="dialogVisible" :close-on-click-modal="true" width="550px">

      <div v-if="!isEdit">
        <el-input size="mini" placeholder="请输入手机号查询" v-model="phone" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="getInfo" :loading="dialogLoading">查询</el-button>
      </div>

      <table class="check-work-tb" style="width: 100%; margin-top: 10px;">
        <tr>
          <th width="100">姓名</th>
          <td>{{userInfo.UserName}}</td>
        </tr>
        <tr>
          <th>手机</th>
          <td>{{userInfo.MobilePhone}}</td>
        </tr>
        <tr>
          <th>部门</th>
          <td>{{userInfo.DepartmentName}}</td>
        </tr>
        <tr>
          <th>考勤点</th>
          <td>{{userInfo.AreaName}}</td>
        </tr>
        <tr>
          <th>出勤设置</th>
          <td>
            <el-select v-model="workdayClass" placeholder="输入关键字搜索" filterable reserve-keyword remote :remote-method="(val) => getWorkClass('workday', val)" :loading="workClassLoading" @change="(val) => showWorkClassDesc('workday', val)">
              <el-option v-for="item in workdayClassOptions" :key="item.work_class_id" :label="item.class_name" :value="item.work_class_id">
                <span style="float: left" :title="(item.on_time_1 ? (item.on_time_1 + '-' + item.off_time_1) : '') + (item.on_time_2 ? (', ' +  item.on_time_2 + '-' + item.off_time_2) : '')">{{ item.class_name }}{{item.class_short_name ? '('+item.class_short_name+')' : ''}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.department_name ? item.department_name : (item.department_id == '0' ? '通用': '') }}</span>
              </el-option>
            </el-select>
            {{workdayClassDesc}}
          </td>
        </tr>
        <tr>
          <th>公休设置</th>
          <td>
            <el-select v-model="holidayClass" placeholder="输入关键字搜索" filterable reserve-keyword remote :remote-method="(val) => getWorkClass('holiday', val)" :loading="workClassLoading">
              <el-option v-for="item in holidayClassOptions" :key="item.work_class_id" :label="item.class_name" :value="item.work_class_id">
                <span style="float: left">{{ item.class_name }}({{item.class_short_name}})</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.department_name ? item.department_name : (!item.department_id ? '通用': '') }}</span>
              </el-option>
            </el-select>
            {{holidayClassDesc}}
          </td>
        </tr>
        <tr v-if="userInfo.UserID">
          <th>操作</th>
          <td>
            <div v-if="isEdit">
              <el-button size="mini" type="primary" @click="save()" :loading="dialogLoading">保存</el-button>
            </div>
            <div v-else>
              <span v-if="userInfo.AdminId > 0">已添加</span>
              <el-button size="mini" type="primary" @click="add(userInfo.MobilePhone)" :loading="dialogLoading" v-else>添加</el-button>
            </div>
          </td>
        </tr>
      </table>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button> -->
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import { Admin } from './common.js'

export default {
  name: "CheckWorkAdmin",
  data() {
    return{
      keyword: '',
      dialogVisible: false,
      phone: '',
      workdayClass: '',
      holidayClass: '',
      searchList: [],
      searchLoading: false,
      dialogLoading: false,
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      workdayClassOptions: [],
      holidayClassOptions: [],
      workdayClassDesc: '',
      holidayClassDesc: '',
      workClassLoading: false,
      userInfo: null,
      isEdit: false,
    }
  },
  beforeMount() {
    this.setUserInfo()
  },
  mounted() {

    this.getList()
  },
  methods:{

    setUserInfo() {
      this.userInfo = {
        AdminId: null,
        DepartmentID: "",
        DepartmentName: "",
        MobilePhone: "",
        UserID: "",
        UserName: "",
      }
    },

    //
    showAddDialog(item) {
      this.phone = ''
      this.workdayClassDesc = ''

      if(item) {
        this.userInfo = {
          AdminId: item.id,
          UserID: item.user_id,
          UserName: item.user_name,
          MobilePhone: item.phone_number,
          DepartmentName: item.department_name,
          AreaName: item.area_name,
        }
        this.workdayClass = item.workday_work_class
        this.holidayClass = item.holiday_work_class
        this.workdayClassOptions = [{work_class_id: item.workday_work_class, class_name: item.workday_class_name, class_short_name: item.workday_class_short_name, on_time_1: item.workday_on_time_1, off_time_1: item.workday_off_time_1, on_time_2: item.workday_on_time_2, off_time_2: item.workday_off_time_2}]
        this.holidayClassOptions = [{work_class_id: item.holiday_work_class, class_name: item.holiday_class_name, class_short_name: item.holiday_class_short_name}]
        this.isEdit = true
        this.showWorkClassDesc('workday', item.workday_work_class)
      } else {
        this.workdayClass = '',
        this.holidayClass = '',
        this.setUserInfo()
        this.getWorkClass('workday', '')
        this.getWorkClass('holiday', '')
        this.isEdit = false
      }

      this.dialogVisible = true
    },

    hideAddDialog() {
      this.dialogVisible = false
    },

    // 查询员工信息
    getInfo() {

      this.dialogLoading = true
      Admin.getInfo({phone: this.phone}, res => {

        if(res.code != 0) {
          this.$message.error(res.msg)
          this.setUserInfo()
        } else {
          this.userInfo = res.data
        }

        this.dialogLoading = false

      })
    },

    // 添加管理员操作
    add(phone) {

      this.dialogLoading = true
      Admin.add({phone: phone, workday_work_class: this.workdayClass, holiday_work_class: this.holidayClass}, res => {
        this.$message({
          type: res.code == 0 ? 'success' : 'error',
          message: res.msg,
        })

        if(res.code == 0) {
          this.hideAddDialog()
          this.getList()
        }

        this.dialogLoading = false

      })
    },

    // 获取管理员列表
    getList() {
      this.searchLoading = true
      Admin.getList({keyword: this.keyword, page: this.page, page_size: this.pageSize}, res => {
        if(res.code == 0) {
          this.total = res.data.total
          this.tableData = res.data.list ? res.data.list.map(item => {
            item.status = item.status == 1
            return item
          }) : []
        } else {
          this.$message.error(res.msg)
        }
        this.searchLoading = false
      })
    },

    pageChange(i) {
      this.page = i
      this.getList()
    },

    // 更新权限
    updateStatus(id, status) {
      Admin.updateStatus({id: id, status: status}, res => {
        this.$message({
          type: res.code == 0 ? 'success' : 'error',
          message: res.msg,
        })
      })
    },

    deleteAdmin(item) {
      this.$confirm('此操作将删除管理员['+item.user_name+'], 是否继续?', '提示', {type: 'warning'}).then(() => {
        Admin.delete({id: item.id}, res => {
          this.$message({
            type: res.code == 0 ? 'success' : 'error',
            message: res.msg,
          })
          if(res.code == 0) this.getList()
        })
      })
    },

    getWorkClass(type, val) {
      this.workClassLoading = true
      Admin.getWorkClass({type: type, keyword: val}, res => {
        this[type + 'ClassOptions'] = res.data
        setTimeout(res => {
          this.workClassLoading = false
        }, 100)
      })
    },

    save() {

      this.dialogLoading = true
      Admin.save({
        id: this.userInfo.AdminId,
        workday_work_class: this.workdayClass,
        holiday_work_class: this.holidayClass,
      }, res => {

        this.$message({
          type: res.code == 0 ? 'success' : 'error',
          message: res.msg,
        })

        if(res.code == 0) {
          this.dialogLoading = false
          this.dialogVisible = false
          this.getList()
        }

      })

    },

    showWorkClassDesc(type, val) {

      this.workdayClassDesc = ''
      if(val) {
        let desc = []
        this.workdayClassOptions.forEach(item => {
          if(item.work_class_id == val) {
            if(item.on_time_1) desc.push(item.on_time_1 + '-' + item.off_time_1)
            if(item.on_time_2) desc.push(item.on_time_2 + '-' + item.off_time_2)
            this.workdayClassDesc = '（' + desc.join(',', desc) + '）'
          }
        })
      }

    }

    // end methods
  }
}
</script>

<style lang="scss" scoped>
  @import './common.scss';


</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/CheckWorkAdmin.vue